import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferRequestProductQuery, OfferRequestProductVo, SubmitProductRequestQuery } from './type';

/**
 * 根据类型获取获取业务数据。类型：Game Service、Digital Product、Fifa，不传默认查询全部
  GET /product/product-common/getBusinessByType
  接口ID：270459481
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-270459481
 */
export const getBusinessOptions = (params?: OfferRequestProductQuery): AxiosPromise<OfferRequestProductVo> => {
  return request({
    url: '/product/product-common/getBusinessByType',
    method: 'get',
    params
  });
};

/**
 * 卖家提交新商品的申请
  POST /product/offerManage/submitApplyProduct
  接口ID：270465025
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-270465025
 */
export const postProductRequest = (data: SubmitProductRequestQuery): AxiosPromise => {
  return request({
    url: '/product/offerManage/submitApplyProduct',
    method: 'post',
    data
  });
};

/**
 * 卖家保证金缴费检查
  GET /product/offerManage/verifyDepositInfo
  接口ID：
  接口地址：
 */
export const postVerifyDepositInfo = (params: { entityId: string; businessId: string }) => {
  return request({
    url: `product/offerManage/verifyDepositInfo?entityId=${params.entityId}&businessId=${params.businessId}`,
    method: 'get'
  });
};
